import React from 'react';
import ReactTable from 'react-table';

import moment from 'moment';
import DatePicker from 'react-datepicker';

import queryString from 'query-string';

export class TableComponent extends React.Component {
  initialState = {};

  state = {};

  apiPath = '';
  addDay = true;

  makeColumns = () => {
    return [];
  };

  getInitialState = (initialState) => {
    let state = {};
    Object.assign(state, initialState);
    return state;
  };

  subscription = (model, cb) => this.forceUpdate(cb);

  componentWillMount() {
    this.getLocationQuery();
    this.initialState.search = this.initialState.search || '';
    this.initialState.currentSearch = this.initialState.currentSearch || '';
    this.initialState.from = this.initialState.from || moment();
    this.initialState.to = this.initialState.to || moment();
    this.initialState.limit = this.initialState.limit || 10;
    this.initialState.page = this.initialState.page || 0;
    this.initialState.sort = this.initialState.sort || false;
    this.initialState.columns = this.initialState.columns || [];
    this.initialState.last = this.initialState.last || false;
    if (this.props.initial || this.resetOnMount) {
      this.initialState = this.getInitialState(this.initialState);
      this.initialState.columns = this.makeColumns();
      this.props.setState(this.initialState, () => {
        if (!this.tableParams.manual) {
          this.fetchData();
        }
      });
    } else {
      this.page = this.props.state.page || 0;
      this.sorted = this.props.state.sorted || this.tableParams.sorted;
      this.pageSize = this.props.state.pageSize || this.tableParams.defaultPageSize || 10;
      this.props.setState({ columns: this.makeColumns() });
    }
    this.componentWillMount2();
  }
  componentWillMount2() {}

  handleToggleData = (newValue, props, key, isString) => {
    if (!key) {
      key = props.column.id;
    }
    if (!isString) newValue = Number(newValue);
    props.value = newValue;
    props.original[key + '_original'] = props.original[key];
    props.original[key] = newValue;
    let items = this.props.items;
    items[props.index][key] = newValue;
    this.props.changeItems(items);
    this.handleSubmitData(props, key);
  };

  handleChangeData = (newValue, props, key, noTimeout) => {
    let items = this.props.items;
    if (typeof key == 'undefined') {
      key = props.column.id;
    }
    let item = items[props.index];
    if (item) {
      item[key + '_original'] = item[key];
      item[key] = newValue;
      this.props.changeItems(items);
      if (!noTimeout) {
        let timeoutKey = key + '_timeout';
        if (item[timeoutKey]) {
          clearTimeout(item[timeoutKey]);
        }
        item[timeoutKey] = setTimeout(() => {
          this.handleSubmitData(props, key);
        }, 500);
      }
    } else {
      console.warn('TableComponent.handleChangeData error: no row in items', data, props);
    }
  };

  handleSubmitData = (props, key) => {
    if (!key) {
      key = props.column.id;
    }
    if (!this.editApiPath) {
      console.warn('TableComponent.handleSubmitData error: editApiPath not set');
      return;
    }
    if (props.original[key + '_timeout']) {
      clearTimeout(props.original[key + '_timeout']);
      delete props.original[key + '_timeout'];
    }

    let value = props.original[key];
    let originalValue = props.original[key + '_original'];
    let savedValue = props.original[key + '_saved'];
    if (value == savedValue) {
      console.log('already saved');
      return;
    } else if (typeof originalValue == 'undefined') {
      console.log('wasnt changed');
      return;
    } else {
      props.original[key + '_saved'] = value;
    }

    if (typeof value == 'undefined') {
      console.warn('TableComponent.handleSubmit error: value undefined', key);
      return;
    }
    this.props
      .api(this.editApiPath, {
        id: props.original.id || props.original.aid || props.original.member_id,
        key: key,
        value: value
      })
      .then((res) => {
        if (!res || res.result == 0) {
          this.handleChangeData(originalValue, props, key, true);
        } else {
          props.original[key + '_original'] = value;
        }
      });
  };

  handleChangeSearch = (e) => {
    const search = e.target.value;
    this.props.setState({ search });
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(this.submitSearch, 300);
  };

  handleChangeInput = (key, e) => {
    const search = e.target.value;
    this.props.setState({ [key]: e.target.value });
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(this.submitSearch, 300);
  };

  submitSearch = (e) => {
    e && e.preventDefault();
    clearTimeout(this.searchTimeout);
    let state = this.props.state;
    if (!state.lastParams || state.search != state.lastParams.search) {
      this.fetchData();
    }
  };

  submitInput = (key, e) => {
    e && e.preventDefault();
    clearTimeout(this.searchTimeout);
    let state = this.props.state;
    if (!state.lastParams || state[key] != state.lastParams[key]) {
      this.fetchData();
    }
  };

  locationQuery = {};
  getLocationQuery = () => {
    const loc = this.props.location;
    if (!loc) return;
    var query = queryString.parse(loc.search);
    if (loc.state && loc.state.from && loc.state.from.search) {
      query = queryString.parse(loc.state.from.search);
    }
    this.locationQuery = query;
    return;
  };

  searchElement = (customClass) => {
    customClass = customClass || '';
    return (
      <form onSubmit={this.submitSearch} class='tables-search'>
        <input
          class={'form-control form-control-sm pull-right ' + customClass}
          type='search'
          placeholder='Search...'
          name='search'
          defaultValue={this.props.state.search || ''}
          onChange={this.handleChangeSearch}
          onBlur={this.submitSearch}
        />
      </form>
    );
  };

  handleChangeDatepicker = (name, date) => {
    this.props.setState(
      {
        [name]: date
      },
      this.fetchData
    );
  };

  changeDatepickerWeek = (isNext) => {
    let from = moment(this.props.state.from);
    isNext ? from.add(7, 'days') : from.subtract(7, 'days');
    from = from.isoWeekday(1);
    let to = from.clone().add(6, 'days');
    this.props.setState({ from, to }, this.fetchData);
  };

  datepickerElement = (params = {}) => {
    params = params || {};
    let { format = 'D MMM YYYY', disabled, weekArrows = false } = params;
    // "DD-MM-YYYY"
    let popperModifiers = {
      // offset: {
      //   enabled: true,
      //   offset: '5px, 10px'
      // },
      // preventOverflow: {
      //   enabled: true,
      // escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
      // boundariesElement: 'viewport'
      // }
    };
    return (
      <div class='d-inline-block table-datepicker-container'>
        {!!weekArrows && (
          <button
            type='button'
            style={{ verticalAlign: 'top', backgroundColor: 'rgba(0,0,0,0.2)' }}
            class={'btn btn-sm primary mr-2'}
            onClick={this.changeDatepickerWeek.bind(this, false)}
          >
            {'<'}
          </button>
        )}
        <div class='d-inline-block table-datepicker-wrap'>
          <DatePicker
            selected={this.props.state.from}
            onChange={this.handleChangeDatepicker.bind(this, 'from')}
            popperPlacement='bottom-start'
            class='form-control form-control-sm table-datepicker'
            name='from'
            dateFormat={format}
            popperModifiers={popperModifiers}
            disabled={!!disabled}
          />
        </div>
        <div class='d-inline-block ml-2 table-datepicker-wrap'>
          <DatePicker
            selected={this.props.state.to}
            onChange={this.handleChangeDatepicker.bind(this, 'to')}
            popperPlacement='bottom-start'
            class='form-control form-control-sm table-datepicker'
            name='to'
            dateFormat={format}
            popperModifiers={popperModifiers}
            disabled={!!disabled}
          />
        </div>
        {!!weekArrows && (
          <button
            type='button'
            style={{ verticalAlign: 'top', backgroundColor: 'rgba(0,0,0,0.2)' }}
            class={'btn btn-sm primary ml-2'}
            onClick={this.changeDatepickerWeek.bind(this, true)}
          >
            {'>'}
          </button>
        )}
      </div>
    );
  };

  fetchParams() {
    return {};
  }

  // may need in future:
  // fetchTotalParams(){return {}}

  isEqual(obj1, obj2) {
    if (!obj1 || !obj2) {
      return false;
    }
    var key;
    for (key in obj1) {
      if (obj1[key] !== obj2[key]) {
        console.log('diff in', key, obj1[key], obj2[key]);
        return false;
      }
    }
    for (key in obj2) {
      if (obj1[key] !== obj2[key]) {
        console.log('diff in', key, obj1[key], obj2[key]);
        return false;
      }
    }
    return true;
  }

  fetchData = (options) => {
    options = options || {};
    clearTimeout(this.searchTimeout);
    let propsState = this.props.state;
    let page = this.page || 0;
    let sorted =
      (this.sorted && this.sorted[0]) ||
      (this.tableParams.sorted && this.tableParams.sorted[0]) ||
      {};
    var dateTo = propsState.to.clone();
    if (this.addDay) {
      dateTo = dateTo.add(1, 'days');
    }
    let params = {
      limit: this.pageSize,
      skip: page * this.pageSize,
      order: sorted.id,
      desc: sorted.desc,
      from: propsState.from.format('DD-MM-YYYY'),
      to: dateTo.format('DD-MM-YYYY')
    };
    if (typeof propsState.search != 'undefined') {
      params.search = propsState.search;
    }
    if (typeof propsState.type != 'undefined') {
      params.type = propsState.type;
    }
    let totalParams = {
      search: params.search,
      type: params.type,
      from: params.from,
      to: params.to,
      page_size: params.limit
    };
    let additionalParams = this.fetchParams();
    for (let key in additionalParams) {
      params[key] = additionalParams[key];
      totalParams[key] = additionalParams[key];
    }
    let lastParams = propsState.lastParams;
    if (lastParams) {
      delete lastParams.load_total;
      if (this.isEqual(params, lastParams) && !options.forceReload) {
        console.log('same state, not loading');
        return;
      }
    }
    params['load_total'] =
      !this.isEqual(totalParams, propsState.lastTotalParams) || options.forceReload;
    this.props.setState({ lastParams: params, lastTotalParams: totalParams }, () => {
      this.props.api(this.apiPath, params);
    });
  };

  tableParams = {
    class: '',
    sorted: [],
    defaultPageSize: 10,
    showPagination: true
  };
  reactTable = () => {
    let params = this.tableParams || {};
    let { items, loading, pages, count } = this.props;
    let manual = !!params.manual;
    if (this.props.state.initial) {
      return '';
    }
    if (!this.pageSize) this.pageSize = params.defaultPageSize || 10;
    if (!this.page) this.page = 0;
    if (!this.sorted) this.sorted = this.tableParams.sorted;
    count = count || (items && items.length) || 0;
    let showAll = (params.showAll && count > 0) || false;
    return (
      <ReactTable
        columns={this.props.state.columns || []}
        {...(manual ? { manual: true } : {})}
        onFetchData={manual ? (s) => this.fetchData() : undefined}
        pages={pages}
        page={this.page}
        sorted={this.sorted}
        onPageChange={this.onPageChange}
        onSortedChange={this.onSortedChange}
        data={items}
        loading={loading}
        pageSize={showAll ? count : this.pageSize}
        defaultPageSize={showAll ? count : undefined}
        showPagination={showAll ? false : true}
        onPageSizeChange={this.onPageSizeChange}
        className={'-striped -highlight ' + (this.tableParams.class || '')}
        multiSort={false}
        filterable={!!params.filterable}
        defaultSortDesc={true}
      />
    );
  };

  onPageChange = (pageIndex) => {
    // console.log("onPageChange",pageIndex)
    this.page = pageIndex;
    this.props.setState({ page: pageIndex });
    this.setState({ page: pageIndex });
  };

  onSortedChange = (newSorted, column, shiftKey) => {
    console.log('onSortedChange', newSorted[0]);
    // newSorted[0].desc = !newSorted[0].desc
    this.sorted = newSorted;
    this.page = 0;
    this.props.setState({ sorted: newSorted, page: this.page });
    this.setState({ sorted: newSorted, page: this.page });
  };

  onPageSizeChange = (pageSize, page) => {
    this.pageSize = pageSize;
    this.props.setState({ pageSize });
  };

  changeType = (e, notload) => {
    let target = e.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    let page = notload ? this.page : (this.page = 0);

    this.props.setState(
      {
        [target.name]: value,
        page: page
      },
      () => {
        if (notload) {
          this.props.setState({ columns: this.makeColumns() });
          this.setState(this.props.state);
        } else {
          this.fetchData();
          this.props.setState({ columns: this.makeColumns() });
          this.setState(this.props.state);
        }
      }
    );
  };

  typeButton = (name, value, classes, onClick, nameType) => {
    nameType = nameType || 'type';
    let type = this.props.state[nameType];
    classes = classes || '';
    return (
      <button
        type='button'
        class={'btn btn-sm primary ' + classes + (type == value ? ' active' : '')}
        name={nameType}
        value={value}
        onClick={onClick ? onClick : this.changeType}
      >
        {name}
      </button>
    );
  };
}

import api from '../actions/api';
import { connect as reduxConnect } from 'react-redux';

export function connect(Component, apiName, reducers, actions, withRef) {
  reducers =
    reducers ||
    function () {
      return {};
    };

  actions = actions || {};
  actions.changeItems = function changeItems(items) {
    return (dispatch) => {
      dispatch({
        type: 'api_success',
        key: apiName,
        items: items
      });
    };
  };
  actions.setState = function (data, cb) {
    return {
      type: 'state_set',
      key: apiName,
      data: data,
      cb: cb
    };
  };

  actions.api = api;

  return reduxConnect(
    function (state) {
      let additionalState = reducers(state);
      let apiState = state.api[apiName] || state.api.initial;
      let newState = {
        ...apiState,
        pages: apiState.total.pages || (apiState.data && apiState.data.pages) || 1,
        count: apiState.total.count || (apiState.data && apiState.data.count) || 0,
        state: state.state[apiName] || state.state.initial,
        user: state.session.user
      };
      for (let key in additionalState) {
        newState[key] = additionalState[key];
      }
      return newState;
    },
    actions,
    null,
    withRef ? { withRef: true } : {}
  )(Component);
}
